import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const SubsidiaryProductsPage = lazy(
  () => import('~/features/platform/pages/subsidiary-products-page'),
);

export const Route = createFileRoute(
  '/_authenticated/_tenant/platform/subsidiaries/$subsidiaryId/products',
)({
  component: function RouteComponent() {
    const { subsidiaryId } = Route.useParams();
    return (
      <Suspense fallback={<PageSkeleton />}>
        <SubsidiaryProductsPage subsidiaryId={subsidiaryId} />
      </Suspense>
    );
  },
});
